import styled from "styled-components"

export const Board = styled.div`
  .section-form .ant-form-item-explain {
    display: none;
  }

  .task-modal-popover {
    padding: 0px;
  }

  .section-tooltip {
    margin-left: 8px;
  }

  .ant-popover-arrow {
    display: none;
  }

  .ant-card-sticky {
    margin-bottom: 0;
  }

  .bi-three-dots {
    transition: fill 250ms;
  }

  .ant-btn:hover .bi-three-dots,
  .ant-btn:active .bi-three-dots {
    fill: #07c5b7;
  }
`
